import { render, staticRenderFns } from "./Infomodal.vue?vue&type=template&id=a4a5b0d8&"
import script from "./Infomodal.vue?vue&type=script&lang=js&"
export * from "./Infomodal.vue?vue&type=script&lang=js&"
import style0 from "./Infomodal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports